import { type Plugin } from 'vue';
import { createVuetify } from 'vuetify';

import { flagsSet } from '../icons/flags/flagsSet';
import deDE from '../translations/vuetify/de-DE.json';
import enUS from '../translations/vuetify/en-US.json';
import frFR from '../translations/vuetify/fr-FR.json';
import { defaultOptions, type SharedPluginOptions } from './sharedPluginOptions';

export const setupVuetify: (options?: Partial<SharedPluginOptions>) => Plugin = (options?: Partial<SharedPluginOptions>) => createVuetify({
	display: {
		mobileBreakpoint: 'sm',
		thresholds: {
			xs: 0,
			sm: 960
		}
	},
	theme: {
		defaultTheme: options?.theme ?? defaultOptions.value.theme,
		themes: options?.themes ?? defaultOptions.value.themes
	},
	defaults: {
		global: {
			ripple: false
		}
	},
	icons: {
		sets: {
			flags: flagsSet
		}
	},
	locale: {
		locale: options?.locale ?? defaultOptions.value.locale,
		fallback: options?.fallbackLocale ?? defaultOptions.value.fallbackLocale,
		messages: {
			'de-DE': deDE,
			'en-US': enUS,
			'fr-FR': frFR
		}
	}
});